module.exports = __webpack_public_path__ + "static/media/Raspberries.dd64f28b.png";